import { computed, defineComponent, onMounted, reactive } from 'vue';
import { useDateFormat } from '@/composables/dateFormat';
import { useStore } from 'vuex';
import { VideoAction, VideoGetter } from '@/store/video/video.module';
import { Video } from '@/store/video/video.model';
import LoadingComponent from '@/components/loading/Loading.vue';
import PaginateComponent from '@/components/paginate/Paginate.vue';

export default defineComponent({
  name: 'VideoListComponent',
  components: {
    LoadingComponent,
    PaginateComponent
  },
  emits: [
    'edit'
  ],
  setup: (_, context) => {
    const dateFormat = useDateFormat();
    const store = useStore();
    const videos = computed<Video[]>(() => store.getters[VideoGetter.ALL]);
    const search = computed(() => videos.value.filter((video) => toSearch(video)));
    const display = computed(() => search.value.filter((_, index) => toDisplay(index)));
    const isLoading = computed(() => store.getters[VideoGetter.STATUS] === 'init' || store.getters[VideoGetter.STATUS] === 'loading');

    onMounted(() => {
      store.dispatch(VideoAction.FETCH);
    });

    const filter = reactive({
      keyword: '',
      amount: computed(() => search.value.length),
      total: computed(() => videos.value.length)
    });

    const page = reactive({
      size: 6,
      current: 1
    });

    const toSearch = (video: Video): Video | boolean => {
      return (filter.keyword)
        ? video.title.toLowerCase().includes(filter.keyword.toLowerCase())
          ? video
          : false
        : true;
    };

    const toDisplay = (index: number) => {
      const start = (page.current - 1) * page.size;
      const end = start + page.size;
      return index >= start && index < end;
    };

    const editClick = (id: number) => {
      context.emit('edit', id);
    };

    const toggleClick = (id: number) => {
      const video = videos.value.find(m => m.id == id);
      store.dispatch(VideoAction.PINNING, {
        id: id,
        pined: !video?.pined,
      });
    };

    const selectedPage = (pageNumber: number) => {
      page.current = pageNumber;
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'short');

    return {
      isLoading,
      display,
      filter,
      page,
      editClick,
      selectedPage,
      toggleClick,
      thaiDate,
    };
  },
});
